import React, { useState, useEffect } from 'react';
import { getUserSettings, saveUserSettings } from '../services/api';
import UserSettingsForm from './UserSettingsForm';
import EmailRecipientsForm from './EmailRecipientsForm';

function SettingsPage() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUserSettings()
      .then((data) => setSettings(data?.settings ?? data))
      .catch(() => setSettings(null))
      .finally(() => setLoading(false));
  }, []);

  const handleSaveSettings = async (newSettings) => {
    await saveUserSettings(newSettings);
    const updated = await getUserSettings();
    setSettings(updated?.settings ?? updated);
  };

  if (loading) return <div className="loading">Loading settings...</div>;

  return (
    <div className="settings-page">
      <h2>Settings</h2>
      <div className="settings-section">
        <EmailRecipientsForm />
      </div>
      <div className="settings-section">
        <UserSettingsForm settings={settings} onSave={handleSaveSettings} />
      </div>
    </div>
  );
}

export default SettingsPage;
